// extracted by mini-css-extract-plugin
export var hidden = "_vk-0";